import { useEffect } from 'react'

import { useAppDispatch } from '../common/hooks'
import { setIsInFrame } from '../features/dashboard'

// Check if the app is in an iframe
export const useIsInFrame = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      setIsInFrame({
        isInFrame: window !== window.parent,
      })
    )
  }, [])
}
